// extracted by mini-css-extract-plugin
export default {"shift_list":"ShiftList_shift_list__UIMXr","date_title":"ShiftList_date_title__37TO-","spin":"ShiftList_spin__5r0Tn","fadeInDown":"ShiftList_fadeInDown__uTveJ"};